import React, { Component } from 'react'
import { i18nTranslate } from 'src/utils'
import { Button, Modal } from 'react-bootstrap'
import {
  VOLUME_URL,
} from 'config/appConfig'
import './styles.scss'

class ConversionSuccessPopup extends Component {
  constructor(props) {
    super(props)
    this.warnings = [
      {
        successMessage: (
          <>
            <strong>
              {i18nTranslate(
                'ba_to_member_become_a_member_success_message',
                'You may currently have Brand Affiliates in your downline and/or customers linked to your account. '
              )}
            </strong>
            {i18nTranslate(
              'ba_to_member_become_a_member_success_second_message',
              'If you switch to a Member account, you will permanently lose these connections and no longer earn commissions on product sales.'
            )}
          </>
        ),
      },
      {
        successMessage: (
          <>
            <strong>
              {i18nTranslate(
                'ba_to_member_become_a_member_third_success_message',
                'You may have a pending check or balance on your account.'
              )}
            </strong>{' '}
            {i18nTranslate(
              'ba_to_member_become_a_member_volumes_message',
              'Please visit'
            )}{' '}
            <a href={VOLUME_URL} target="_blank" rel="noopener noreferrer">
              {i18nTranslate(
                'ba_to_member_become_a_member_volumes_link',
                'Volumes'
              )}
            </a>{' '}
            {i18nTranslate(
              'ba_to_member_become_a_member_volumes_second_message',
              'for more information before switching to a Member.'
            )}
          </>
        ),
      },
    ]
  }

  render() {
    const {
      isToShowPopUp = true,
      handleConversionSuccessPopup,
      handleShowPhoneVerificationModal,
    } = this.props

    return (
      <Modal
        show={isToShowPopUp}
        className="conversion-success-modal rounded-md">
        <Modal.Body className="conversion-success-modal">
          <h4 className="conversion-success-modal-title">
            {i18nTranslate(
              'ba_to_member_become_a_member_title',
              'Are you sure you want to switch to a Member account?'
            )}
          </h4>
          <p className="conversion-success-modal-message">
            {i18nTranslate(
              'ba_to_member_become_a_member_message',
              'Members are not eligible to build a team, earn commissions, or purchase products in other markets. They are, however, eligible to earn and redeem loyalty points on subscriptions.'
            )}
          </p>
          <p className="conversion-success-modal-message">
            {i18nTranslate(
              'ba_to_member_become_a_member_second_message',
              'If your account is a Business Builder, or there are holds on your account, you will not be eligible to move to a member.'
            )}
          </p>

          {/* Map through the warnings array */}
          {this.warnings.map((warning, index) => (
            <div data-testid="custom-card" className="custom-card" key={index}>
              <p className="card-content">{warning.successMessage}</p>
            </div>
          ))}

          <div className="row">
            <div className="col-4">
              <Button
                className="acknowledge-button rounded-md"
                variant="outline-primary"
                data-testid="qa-exit-cancel-button"
                block
                onClick={handleConversionSuccessPopup}
                tabIndex={0}>
                {i18nTranslate('cancelOrderForm.cancel', 'Cancel')}
              </Button>
            </div>
            <div className="col-8">
              <Button
                data-testid="qa-acknowledgeButton"
                className="acknowledge-button rounded-md"
                variant="primary"
                type="submit"
                onClick={handleShowPhoneVerificationModal}
                block>
                {i18nTranslate(
                  'ba_to_member_become_a_member_acknowledge_button',
                  'I understand and wish to proceed'
                )}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

export default ConversionSuccessPopup
export { ConversionSuccessPopup }
